var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiSpicy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.499 12.467c.349-.75.99-3.72 1.718-4.484 1.105-.78 2.71-.401 3.025-.119.314.282 1.955 1.58 1.613 2.514-.684 1.867-2.139 3.396-3.23 4.543-1.092 1.148-1.825 1.749-6.72 2.472-.837.124 2.71-3.029 3.594-4.926z",
    fill: "#31544e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.545 6.875a.5.5 0 10-.316-.949zM15.74 8.354c.044-.043.09-.103.116-.137l.121-.154a4.89 4.89 0 01.363-.41c.301-.3.704-.611 1.205-.778l-.316-.949c-.7.233-1.23.655-1.596 1.02-.184.185-.33.358-.437.492l-.128.164c-.04.052-.045.055-.035.045z",
    fill: "#333"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--spicy-136a1fdec1cd766a761c56ca89f0292c.svg";
export { SvgIconUiSpicy as Component };